<template>
  <div class="row">
    <div class="col_12">
      <h1 class="common_title">Account Setting</h1>
      <div class="card account_setting_page border_none">
        <div class="card_body">
          <div class="row">
            <div class="col_12">
              <div class="account_setting_tab">
                <nav class="tabs">
                  <ul class="">
                    <li href="#tab1" :class="{active: activeTab === 'profileSettings'}" @click="activeTab = 'profileSettings'">Profile</li>
                    <li href="#tab2" :class="{active: activeTab === 'passwordUpdate'}" @click="activeTab = 'passwordUpdate'">Change Password</li>
                  </ul>
                </nav>
                <div class="tab_content_wrapper border_none pt_0">
                  <div id="tab1" class="tab_content" :class="{show : activeTab === 'profileSettings'}">
                    <div class="fadein">
                      <div class="account_content">
                        <h1 class="common_sub_title d_flex_btwn mt_0"> <span> Profile Info</span></h1>
                        <div class="row">
                          <div class="col_6">
                            <div class="form_row" :class="{'has_error': errorFor('first_name')}">
                              <label>First Name</label>
                              <div class="form_input">
                                <input type="text" v-model="user.first_name" class="form_global mr_5">
                              </div>
                              <v-errors :errors="errorFor('first_name')"></v-errors>
                            </div>
                          </div>
                          <div class="col_6">
                            <div class="form_row" :class="{'has_error': errorFor('last_name')}">
                              <label>Last Name</label>
                              <div class="form_input">
                                <input type="text" v-model="user.last_name" class="form_global" >
                              </div>
                              <v-errors :errors="errorFor('last_name')"></v-errors>
                            </div>
                          </div>
                        </div>
                        <div class="form_row" :class="{'has_error': errorFor('email')}">
                          <label>Email</label>
                          <div class="form_input center_horizontally">
                            <input type="email" v-model="user.email" class="form_global">
                          </div>
                          <v-errors :errors="errorFor('email')"></v-errors>
                        </div>

                        <div :class="['form_row', {'has_error': errorFor('timezone')}]">
                          <label class="required">Timezone</label>
                          <Multiselect
                              v-model="timezoneModel"
                              :options="timeZones"
                              :multiple="false"
                              :close-on-select="true"
                              placeholder="Select a timezone"
                              label="name"
                              track-by="timezone"
                              :optionHeight="20"
                          />
                          <v-errors :errors="errorFor('timezone')"></v-errors>
                        </div>

                        <div class="form_row ">
                          <label>
                            Profile Image
                          </label>
                          <div class="form_input center_horizontally">
                            <input type="file" class="form_global" accept="image/png, image/gif, image/jpeg" @input="onFileChange($event)">
                          </div>
                          <div class="form_row_inline mt_10" v-if="tempFile">
                            <div class="inner_img p_relative display_inline">
                              <div class="cross_ic" @click.prevent="deleteFile">
                                <i class="fas fa-times"></i>
                              </div>
                              <img :src="tempFile" alt="" height="100" width="100">
                            </div>
                          </div>
                          <div v-else class="mt_10">
                            <img v-if="user.profile_image" :src="user.profile_image" alt="" class="" width="100" height="100">
                          </div>
                        </div>
                        <div class="form_row_inline">
                          <div class="form_input width_full d_flex_end">
                            <button class="btn  btn_primary" :disabled="loading" @click.prevent="updateProfile">Update</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="tab2" class="tab_content" :class="{show : activeTab === 'passwordUpdate'}">
                    <div class="fadein">
                      <div class="account_content">
                        <h1 class="common_sub_title d_flex_btwn mt_0"> <span>Update Password</span></h1>
                        <div class="form_row" :class="{'has_error': errorFor('password')}">
                          <label >
                            Current Password
                          </label>
                          <div class="form_input center_horizontally">
                            <input type="password" v-model="form.password" class="form_global" placeholder="********" autocomplete="off">
                          </div>
                          <v-errors :errors="errorFor('password')"></v-errors>
                        </div>
                        <div class="form_row" :class="{'has_error': errorFor('new_password')}">
                          <label >
                            New Password
                          </label>
                          <div class="form_input">
                            <input type="password" v-model="form.new_password" class="form_global" placeholder="********" autocomplete="off">
                          </div>
                          <v-errors :errors="errorFor('new_password')"></v-errors>
                        </div>
                        <div class="form_row" :class="{'has_error': errorFor('new_password_confirmation')}">
                          <label >
                            Confirm Password
                          </label>
                          <div class="form_input ">
                            <input type="password" v-model="form.new_password_confirmation" class="form_global" placeholder="********" autocomplete="off">
                          </div>
                          <v-errors :errors="errorFor('new_password_confirmation')"></v-errors>
                        </div>
                        <div class="form_row_inline">
                          <div class="form_input width_full d_flex_end">
                            <button class="btn  btn_primary" :disabled="loading" @click.prevent="updatePassword">Update</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Multiselect from "vue-multiselect";

export default{
  name : 'ProfileIndex',
  components: {Multiselect},
  data() {
    return{
      activeTab: 'profileSettings',
      baseUrl: process.env.VUE_APP_BASE,
      tempFile: null,
      form: {
        password: '',
        new_password: '',
        new_password_confirmation: '',
        timezone: null
      },
      loading: false,
      timeZones: []
    }
  },
  computed:{
    ...mapGetters({
      user: "auth/getUserInfo"
    }),
    timezoneModel: {
      get() {
        // Find object by id
        return this.timeZones.find(tz => tz.timezone === this.user.timezone) || null;
      },
      set(selected) {
        this.user.timezone = selected ? selected.timezone : null;
      }
    }
  },
  mounted() {
    this.getTimezonesList()
  },
  methods:{
    updateProfile(){
      this.allErrors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.user).forEach(key => {
        formData.append(key, this.user[key] ? this.user[key] : '');
      })

      this.axios.post('/update-profile', formData)
          .then(({data}) => {
            this.showSuccessMsg("Updated Successfully!");
            console.log(data.data)
            this.$store.dispatch('auth/userInfo', data.data)
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
          })
          .finally(() => {
            this.loading = false;
          })
    },
    onFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]
      this.user.file = file

      this.tempFile = URL.createObjectURL(file);
    },
    deleteFile(){
      this.tempFile = null
      this.user.profile_image = null
    },
    updatePassword(){
      this.allErrors = null
      this.axios.post('/change-password', this.form).then(({ data }) => {
        if (data.success) {
          this.showSuccessMsg("Updated Successfully!");
          this.form = {
            password: '',
            new_password: '',
            new_password_confirmation: '',
          }
        } else {
          this.showFailMsg(data.message);
        }
      }).catch((error) => {
        this.allErrors = error.response.data.errors
      })
    },
    getTimezonesList() {
      this.axios.get('/timezones').then(({ data }) => {
        this.timeZones = data.data
      })
    },
    onTimezoneSelect(selected) {
      this.form.timezone = selected ? selected.timezone : null;
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.text_center{
  text-align: center;
}
.card_height{
  height: 100% !important;
}
.p_relative{
  position: relative;
}
.display_inline{
  display: inline-block;
  margin-right: 10px;
}
.cross_ic {
  position: absolute;
  right: 7px;
  top: 7px;
  background: gray;
  padding: 5px;
  border-radius: 50%;
  z-index: 2;
  color: #fff;
  width: 15px;
  height: 15px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>